import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import {
  getSubSegmentsByName,
  setSelectedSegment,
  setSelectedSubsegment,
  getSellersWithDigitalProducts,
} from "../../../Redux/publicseller-apis-for-bookings/slice";
import { SubSegment } from "../../../Redux/publicseller-apis-for-bookings/types";

const BookAppointmentList = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    subSegmentsMap,
    selectedSegment,
    selectedSubsegment,
    search,
    location,
    pagination,
  } = useSelector((state: RootState) => state.segment);

  const segments = [
    { title: "Hospitals", key: "hospital" },
    { title: "Service", key: "service" },
    { title: "Beauty and Fitness", key: "beauty and fitness" },
  ];

  useEffect(() => {
    segments.forEach((segment) => {
      dispatch(getSubSegmentsByName(segment.key));
    });
     dispatch(
      getSellersWithDigitalProducts({
        page: 1,
        limit: pagination.limit,
      }),
    );
  }, [dispatch]);

  const handleSubSegmentClick = (segmentTitle: string, subsegmentName: string) => {
    dispatch(setSelectedSegment(segmentTitle));
    dispatch(setSelectedSubsegment(subsegmentName));
    dispatch(
      getSellersWithDigitalProducts({
        segment: segmentTitle,
        subsegment: subsegmentName,
        search,
        location,
        page: 1,
        limit: pagination.limit,
      }),
    );
  };

  return (
    <>
      <div>
        {segments.map((segment, segmentIndex) => (
          <div className=" mt-2 mb-4" key={segment.key}>
            <div className=" d-flex justify-content-between align-items-center">
              <div className=" w-100">
                <b className=" text-black fw-bolder text-uppercase">{segment.title}</b>
              </div>
              <div className=" w-10 text-end">
                <i className="bi bi-chevron-down text-black text-xs"></i>
              </div>
            </div>
            <div
              className="nav flex-column nav-pills ms-n2 mt-1"
              id={`v-pills-tab-${segment.key}`}
              role="tablist"
              aria-orientation="vertical"
            >
              {subSegmentsMap[segment.key]?.map((sub, subIndex) => (
                <button
                  key={sub._id}
                  className={`nav-link ${
                    selectedSubsegment === sub.name ? "active" : ""
                  } text-start d-flex gap-2 ${subIndex > 0 ? "mt-n1" : ""}`}
                  id={`v-pills-${segment.key}-${sub._id}-tab`}
                  data-bs-toggle="pill"
                  data-bs-target={`#v-pills-${segment.key}-${sub._id}`}
                  type="button"
                  role="tab"
                  aria-controls={`v-pills-${segment.key}-${sub._id}`}
                  aria-selected={selectedSubsegment === sub.name ? "true" : "false"}
                  onClick={() => handleSubSegmentClick(segment.key, sub.name)}
                >
                  <div className="form-check mt-n0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectedSubsegment === sub.name}
                      onChange={() => {}} // Controlled by button click
                      id={`check-${sub._id}`}
                    />
                  </div>{" "}
                  {sub.name}
                </button>
              ))}
              {(!subSegmentsMap[segment.key] || subSegmentsMap[segment.key].length === 0) && (
                <div className="ps-3 text-muted text-xs ms-2 mt-1">No items found</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default BookAppointmentList;
